// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__FBdi-","logo":"nav_logo__BA59c"};